import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        bonuses: {
          header: 'PLAYERS_BONUSES_LIST_HEADER',
          button_add_bonus: 'PLAYERS_BONUSES_LIST_ADD_BONUS',
          modal_window: {
            destroy: 'DESTROY',
            destroy_question: 'DESTROY_QUESTION',
            answer_yes: 'ANSWER_YES',
            answer_no: 'ANSWER_NO',
          },
        },
      },
    },
  }));
}
